import React from 'react'
// import logo from './logo.svg';
import { useEffect, useState, useCallback } from 'react';
import '../App.css';
import '../Assets/css/Main.css'
import { Col, Row, Button, Label, Input, Modal, ModalBody, ModalHeader, FormGroup, ModalFooter } from 'reactstrap';
// import DataTable from 'react-data-table-component';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import base from '../Services/BaseService'
import LoadSpinner from './Shared/Loading'
import { useMsal } from "@azure/msal-react";
import { loginRequest } from '../authconfig';

const BudgetModal = ({ id, closeModal, showModalForm, setSaveItem }) => {

    const [pName, setPName] = useState()
    const [cName, setCName] = useState()
    const [eName, setEName] = useState()
    const [vName, setVName] = useState()
    const [loading, setLoading] = useState(false)
    const [showModal, setShowModal] = useState(showModalForm)
    const { instance, accounts } = useMsal();
    const data = {};

    const toggleModal = () => {
        closeModal()
        setShowModal(!showModal);
    }


    const updateBudget = () => {
        data.period = pName;
        data.categoryId = cName;
        data.expense = eName;
        data.value = vName;
        base.update(`Budget/${id}`, data).then(() => {
            toggleModal()
            setSaveItem(new Date().getTime());
        })
    }

    const handleChange = (e) => {
        if (e.target.name === 'period') {
            setPName(e.target.value);
        }
        if (e.target.name === 'category') {
            setCName(e.target.value)
        }
        if (e.target.name === 'expDet') {
            setEName(e.target.value)
        }
        if (e.target.name === 'value') {
            setVName(e.target.value)
        }

        document.getElementById(e.target.id).style.border = '1px solid #cecece';
    }

    const tokenRefresh = useCallback(async () => {
        await instance.acquireTokenSilent({
            ...loginRequest,
            account: accounts[0]
        }).then((response) => {
            sessionStorage.setItem("upn", accounts[0].idTokenClaims.upn);
            sessionStorage.setItem("username", accounts[0].idTokenClaims.name);
            sessionStorage.setItem("authheader", `Bearer ${response.idToken}`);
        }).catch((e) => {
            console.log("Error acquiring token")
        }
        );
    }, [accounts, instance])

    useEffect(() => {
        const getBudgetItem = () => {
            tokenRefresh()
            base.getAll(`Budget/${id}`).then((res) => {
                setPName(res.period);
                setCName(res.categoryId);
                setEName(res.expense);
                setVName(res.value);
            })
            setLoading(false)
        }
        getBudgetItem()
    }, [tokenRefresh, id])


    return (
        <>
            <Modal isOpen={showModal} size="lg" toggle={toggleModal} backdrop="static">
                <ModalHeader className="bg-modal" toggle={toggleModal}><div className="page-header">Edit Budget Item</div></ModalHeader>
                {loading ?
                    <LoadSpinner />
                    :
                    <>
                        <ModalBody>
                            <FormGroup>
                                <Row className="mb-2 align-items-center">
                                    <Col md="3" lg="2">
                                        <Label className="label-text" >Period*</Label>
                                    </Col>
                                    <Col md="9" lg="10">
                                        <Input disabled type="text" className="input-text" name="period" id="period" placeholder="" defaultValue={pName} onChange={handleChange} />
                                    </Col>
                                </Row>
                                <Row className="mb-2 align-items-center">
                                    <Col md="3" lg="2">
                                        <Label className="label-text">Category*</Label>
                                    </Col>
                                    <Col md="9" lg="10">
                                        <Input disabled type="text" className="input-text" name="category" id="category" placeholder="" defaultValue={cName} onChange={handleChange} />
                                    </Col>
                                </Row>
                                <Row className="mb-2 align-items-center">
                                    <Col md="3" lg="2">
                                        <Label className="label-text">Description*</Label>
                                    </Col>
                                    <Col md="9" lg="10">
                                        <Input disabled type="text" className="input-text" name="ExpDesc" id="ExpDesc" placeholder="" defaultValue={eName} onChange={handleChange} />
                                    </Col>
                                </Row>
                                <Row className="mb-2 align-items-center">
                                    <Col md="3" lg="2">
                                        <Label className="label-text">Value*</Label>
                                    </Col>
                                    <Col md="9" lg="10">
                                        <Input type="text" className="input-text" name="value" id="ExpDesc" placeholder="" defaultValue={vName} onChange={handleChange} />
                                    </Col>
                                </Row>
                            </FormGroup>
                        </ModalBody>
                        <ModalFooter>
                            <Button color="secondary" size="sm" className="btn-text b-width" onClick={toggleModal}>Cancel</Button>
                            <Button color="success" size="sm" className="btn-text b-width" onClick={() => updateBudget()}>Save</Button>

                        </ModalFooter>
                    </>
                }
            </Modal>
        </>
    )
}

export default BudgetModal
